import styled from 'styled-components';
import EllipsisStyle from '@sdk/components/ui/EllipsisStyle';
import Href from '@sdk/components/ui/Href';

export default styled(Href)`
  ${EllipsisStyle}
  color: ${({ theme }): string => theme.colors.gray};
  font-size: ${({ theme }): string => theme.fontSizes.l};
`;
